<template>
  <PflegeBaseSectionTemplate
    v-editable="props.blok"
    :data-uid="props.blok._uid"
    :background-color="getPflegeColornameFromHex(props.blok.backgroundColor?.value)"
    :anchor="anchor"
    :text-align="stringOrUndefined(props.blok.textAlign)"
  >
    <template v-if="props.blok.media?.length" #media>
      <Media
        v-for="asset in props.blok.media"
        :key="asset._uid"
        :blok="asset"
        :aspect-ratio="{
          desktop: aspectRatios.xs,
          tablet: aspectRatios.s,
          mobile: aspectRatios.s
        }"
      />
    </template>

    <template v-if="props.blok.intro?.length" #intro>
      <IntroComponent :blok="props.blok.intro[0]" />
    </template>

    <template v-if="props.blok.firstDivider?.length" #firstDivider>
      <Divider :blok="props.blok.firstDivider[0]" />
    </template>

    <template v-if="props.blok.content?.length" #content>
      <PflegeSlider :slides="props.blok.content">
        <template #default="{ slide }">
          <CardComponent :blok="slide" />
        </template>
      </PflegeSlider>
    </template>

    <template v-if="props.blok.secondDivider?.length" #secondDivider>
      <Divider :blok="props.blok.secondDivider[0]" />
    </template>

    <template v-if="props.blok.closing?.length" #closing>
      <ClosingComponent :blok="props.blok.closing[0]" />
    </template>

    <template v-if="props.blok.thirdDivider?.length" #thirdDivider>
      <Divider :blok="props.blok.thirdDivider[0]" />
    </template>
  </PflegeBaseSectionTemplate>
</template>

<script setup lang="ts">
import aspectRatios from '../constants/aspectRatios'
import{ type BlokBase, type BlokPalette, type BlokProps, type BlokWithEmpty, type ButtonBlok, type CardComponentBlok, type ClosingComponentBlok, type DividerBlok, type IntroComponentBlok, stringOrUndefined, WPElementMedia, type WPElementMediaBlok, type WPStepListBlok } from '@webcarelbj/shared-bloks'
import { findComponent, type TextAlignment } from '@webcarelbj/shared-components'

const Media = findComponent(WPElementMedia)

export interface StepSectionBlok extends BlokBase {
  slides?: CardComponentBlok[]
  backgroundColor?: BlokPalette
  media?: WPElementMediaBlok[]
  intro?: IntroComponentBlok[]
  content?: WPStepListBlok[]
  actions?: ButtonBlok[]
  alignment?: BlokWithEmpty<TextAlignment>
  closing?: ClosingComponentBlok[]
  firstDivider?: DividerBlok[]
  secondDivider?: DividerBlok[]
  thirdDivider?: DividerBlok[]
  textAlign?: BlokWithEmpty<TextAlignment>
}

const props = defineProps<BlokProps<StepSectionBlok>>()
const anchor = computed(() => {
  return props.blok.intro?.length && props.blok.intro[0].anchor !== null
    ? props.blok.intro[0].anchor
    : ''
})
const { getPflegeColornameFromHex } = usePflegeUtils()
</script>
